import { Link, useParams } from "react-router-dom";
import useScreenName from "../../hooks/useScreenName";
import UnderwritingUiFrame from "./UnderwritingUiFrame";
import UnderwritingUiPageShell from "./UnderwritingUiPageShell";
import {
  UNDERWRITING_UI_EMBED_PAGES,
  UNDERWRITING_UI_ROUTE_PATHS,
} from "./underwritingUi.constants";
import useUnderwritingUiEmbedUrl from "./useUnderwritingUiEmbedUrl";

export default function ExecutionEmbedPage() {
  useScreenName("Underwriting UI");
  const { executionId = "" } = useParams() as { executionId: string };
  const { embedUrl, isLoading, error } = useUnderwritingUiEmbedUrl(
    executionId
      ? { page: UNDERWRITING_UI_EMBED_PAGES.EXECUTION_AUDIT, executionId }
      : null,
    "Execution id required"
  );

  return (
    <UnderwritingUiPageShell
      title="Execution audit"
      subtitle={executionId}
      backTo={UNDERWRITING_UI_ROUTE_PATHS.POLICIES}
      backLabel="Policies"
    >
      <div style={{ padding: "8px 16px", textAlign: "right" }}>
        <Link
          className="btn btn-primary btn-sm"
          to={UNDERWRITING_UI_ROUTE_PATHS.POLICY_SIMULATE}
        >
          Run simulation
        </Link>
      </div>
      <UnderwritingUiFrame
        title={`Execution audit ${executionId}`}
        embedUrl={embedUrl}
        isLoading={isLoading}
        error={error}
        loadingText="Loading execution..."
      />
    </UnderwritingUiPageShell>
  );
}
